import React from 'react';

interface AddGroupBarProps {
  reloadTable: () => void;
}
export const AddGroupBar = ({ reloadTable }: AddGroupBarProps) => {
  return <div>Add Group</div>;
};
